module.exports = __webpack_public_path__ + "static/media/img3-2.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/nutricheck_foliar/N/img3-2.png
// module id = 1946
// module chunks = 3